import loadable from '@loadable/component';
import React, { useEffect, useState } from 'react';

import { Contract } from 'src/entities/Contract';
import { PendingContract } from 'src/legacy/components/Contracts/PendingContract';
import { ContractStatus } from 'src/services/api/contractsApi';
import { S3Utils } from 'src/utils';

const PdfViewer = loadable(() => import('src/legacy/components/UI/PDFViewer'));

interface ContractPreviewModalContentProps {
  contract: Contract;
}

export const ContractPreviewModalContent: React.FC<
  ContractPreviewModalContentProps
> = ({ contract }) => {
  const [filePreviewUrl, setFilePreviewUrl] = useState('');

  useEffect(() => {
    if (contract.status !== ContractStatus.Signed) return;

    const fetchPdfUrl = async () => {
      const { identityId, signedFileUrl } = contract;
      const url = await S3Utils.getFile(signedFileUrl, {
        identityId,
        level: 'protected',
      });
      setFilePreviewUrl(url);
    };

    fetchPdfUrl();
  }, [contract]);

  if (contract.status === ContractStatus.Pending) {
    return (
      <div className="flex-1 min-h-0 overflow-auto bg-gray-100 pt-5">
        <PendingContract contract={contract} />
      </div>
    );
  }

  return (
    <div className="flex-1 min-h-0 overflow-auto bg-gray-100 pt-5">
      {filePreviewUrl && <PdfViewer pdfUrl={filePreviewUrl} />}
    </div>
  );
};
